import {useState,useEffect} from 'react'
import {useSelector} from 'react-redux'
import {envAwarePost} from '../../util/util'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import classes from "./Settings.module.css"

const Invoice = ({invoice})=>{
	return (
		<div style={{marginBottom:'8px',borderBottom:'1px solid #ccc',paddingBottom:'8px'}}>
			
			<div className="d-flex justify-content-between align-items-start flex-wrap">
				<div>{invoice.description}</div>
				<div style={{flex:'0 0 auto'}}>
					<small className="mr-2">Pay period:</small>
					<small>{new Date(invoice.period.start).toLocaleDateString()}</small>
					<small className="mx-1">-</small>
					<small>{new Date(invoice.period.end).toLocaleDateString()}</small>
				</div>
			</div>
			<a href={invoice.pdf}>download pdf</a>
		</div>
	)
}

const InvoiceHistory = ()=>{
	const premium =useSelector(state=>state.users.current_user.premium)
	const isPremiumAccountOwner = parseInt(premium) >= 2 && parseInt(premium) !== 99
	const [status,setStatus] = useState('pending')
	const [invoices,setInvoices] = useState([])
	const [recent,setRecent] = useState({})
	const [showHistoryModal,setShowHistoryModal] = useState(false)
	
	const fetchInvoiceData = ()=>{
		if (!isPremiumAccountOwner) return
		envAwarePost('api/billing/',{action:'getInvoiceHistory'}).then(res=>{
			
			if(res.success === '1'){
				setInvoices(res.data.invoices)
				setRecent(res.data.invoices[0])
				setStatus('idle')
			}else{
				window.alert(res.message)
				setStatus('idle')
			}
		})
	}

	useEffect(fetchInvoiceData,[])

	const handleToggleHistory = ()=>{
		setShowHistoryModal(prev=>!prev)
	}

	if(!isPremiumAccountOwner) return null
	return (
		<>
			<Card className={`${classes.cardWidth} mb-5 shadow`}>
				<Card.Body>
					<h4>Invoicing</h4><hr class="mt-1" />
					{status==='pending'?
						<div className="text-center">
							<Spinner animation="border"/>
						</div>
						:
						(
							invoices.length>0?
							<>
								<Row className="mb-3">
									<Col sm={4}>
										Current Plan:
									</Col>
									<Col sm={8} className="mb-2">
										<div>{recent?.description}</div>
									</Col>
								</Row>
								<Row className="mb-3">
									<Col sm={4}>
										Amount
									</Col>
									<Col sm={8} className="mb-2">
										<div>${recent?.amount}/{recent?.interval}</div>
									</Col>
								</Row>
								<Row className="mb-3">
									<Col sm={4}>
										{recent?.on_trial?
											'First Payment:':
											'Next Payment:'
										}
									</Col>
									<Col sm={8} className="mb-2">
										<div>{new Date(recent?.period.end).toLocaleDateString()}</div>
									</Col>
								</Row>
								<Row className="mb-3">
									<Col>
										<Button onClick={handleToggleHistory} block variant="outline-info">
											View History & Download Invoices
										</Button>
									</Col>
								</Row>
							</>
							:
							<Row className="mb-3">
								<Col>
									No invoices yet
								</Col>
							</Row>
						)
					}
				</Card.Body>
			</Card>
			<Modal show={showHistoryModal} onHide={handleToggleHistory} size="lg">
				<Modal.Header closeButton>
					<Modal.Title>Invoice History</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{invoices.map(invoice=><Invoice invoice={invoice}/>)}
				</Modal.Body>
			</Modal>
		</>
	)
}

export default InvoiceHistory